import { FormsComponent } from './../components/forms/forms.component';
import { FormRecordsComponent } from './../components/forms/form-records.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { FormDetailComponent } from './../components/forms/form-detail.component';

export const formsRoutes = {
    path: 'forms',
    data: {
        breadcrumbs: {
            label: 'Formuláře',
            icon: 'forms'
        },
        state: 'forms'
    },
    children: [
        {
            path: '',
            component: FormsComponent
        },
        {
            path: 'view/:id',
            component: FormRecordsComponent,
            data: {
                breadcrumbs: {
                    label: 'Vyplněný formulář',
                    icon: 'forms'
                }
            },
            children: [
                {
                    path: 'formrecord-delete/:id',
                    component: ConfirmationComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Smazat formulářový záznam'
                        },
                        state: 'formrecord-delete',
                        apiUri: 'formrecords'
                    },
                    outlet: 'modal'
                }
            ]
        },
        {
            path: 'add',
            component: FormDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Přidat formulář',
                    icon: 'forms'
                }
            }
        },
        {
            path: 'edit/:id',
            component: FormDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Upravit formulář',
                    icon: 'forms'
                }
            }
        },
        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat formulář'
                },
                state: 'form-delete',
                apiUri: 'forms'
            },
            outlet: 'modal'
        }
    ]
};
